import { Box, ColorOptions, Icon, ModBox, Spacer, SpacerNew, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useRoute } from '@react-navigation/native'
import { useEffect, useState } from 'react'
import Svg, { Path } from 'react-native-svg'
import GlobalSearchBar, { SearchBarTypes } from '../../components/GlobalSearchBar'
import { GlobalSearchBarNew } from '../../components/GlobalSearchBarNew'
import { useLazyApiData, useStores } from '../../data/store'
import { staticStrings } from '../../utils/constants'
import styles from './styles'

const PowerIcon = ({ size = 26, color = '#214796' }: { size?: number; color?: string }) => (
  <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <Path d="M12 2.5 V11" stroke={color} strokeWidth={2} strokeLinecap="round" />
    <Path d="M7.4 6.4 A7 7 0 1 0 16.6 6.4" stroke={color} strokeWidth={2} strokeLinecap="round" fill="none" />
  </Svg>
)

export interface HeaderProps {
  onGoBack?: () => {}
  isLargeScreen?: boolean
}

const Header = ({ onGoBack, isLargeScreen }: HeaderProps) => {
  const [toggle, setToggle] = useState(false)
  const [isHover, setHover] = useState(false)

  const { resetToken, logout, getRecentSearches } = useStores((store) => ({
    resetToken: store.user.resetToken,
    name: store.user.name,
    logout: store.session.logout,
    getRecentSearches: store.getRecentSearches(),
  }))

  const route = useRoute()
  const [lazyLogout, lazyLogoutHandler] = useLazyApiData(logout)

  const onPress = () => {
    setToggle((prev) => !prev)
  }

  useEffect(() => {
    if (lazyLogoutHandler.state === 'fulfilled' || lazyLogoutHandler.state === 'rejected') {
      setToggle(false)
      resetToken()
    }
  }, [lazyLogoutHandler, resetToken])

  const onChange = () => {
    lazyLogout()
  }

  const getModalView = () => {
    if (!toggle) {
      return null
    }
    return (
      <Box {...styles.modalContainer}>
        <Box
          {...styles.hoverContainer}
          onPress={onChange}
          onHover={setHover}
          bg={isHover ? ('#3a3b450a' as ColorOptions) : 'WHITE'}>
          <Icon id="LOGOUT" color="GREY_MATTE" size={12} />
          <SpacerNew direction={'horizontal'} size={8} />
          <Text fontSize={13.6} fontFamily={'jiotype-medium'} color={'#858796' as ColorOptions}>
            {staticStrings.logout}
          </Text>
        </Box>
      </Box>
    )
  }

  const MenuButton = () => {
    if (isLargeScreen) {
      return null
    }
    return (
      <Box onPress={onGoBack} underlayColor="LIGHTEST_GREY">
        <Icon id="MENU" color="BLACK" size={36} />
      </Box>
    )
  }

  const handleResultClick = () => {}
  const navigation = useNavigation()

  const avatar = require('../../assets/images/avatar.png')

  return (
    <Box {...styles.headerContainer}>
      <Box flexDirection="row" alignItems={'center'}>
        <MenuButton />
        <ModBox
          {...styles.searchContainer}
          show={
            route?.name === 'createSingleEntity' ||
            route?.name === 'createEntitySubGroup' ||
            route?.name === 'createEntityGroup' ||
            route?.name === 'searchEntity' ||
            route?.name === 'makerMyQueue' ||
            route?.name === 'checkerGlobalQueue' ||
            route?.name === 'checkerMyQueue' ||
            route?.name === 'createBulkEntities' ||
            route?.name === 'createTID' ||
            route?.name === 'createBulkConfig' ||
            route?.name === 'searchEntityHierarchy'
          }>
          <GlobalSearchBar
            type={SearchBarTypes.DEFAULT}
            recentData={getRecentSearches}
            onResultClicked={handleResultClick}
            navigation={navigation}
          />
        </ModBox>
        <ModBox {...styles.searchContainer} show={NEW_GLOBAL_SEARCH_ROUTES?.includes(route?.name)}>
          <GlobalSearchBarNew
            recentData={getRecentSearches?.filter((item) => !item?.filterKey?.includes('Group'))}
            navigation={navigation}
          />
        </ModBox>
      </Box>

      <Box flexDirection={'row'} onPress={onPress} underlayColor={'TRANSPARENT'} align={'center'}>
        <Box bg={'GREY_1_SEPARATOR'} width={'ONE'} h={36} borderRadius={4} />
        <Spacer direction={'horizontal'} size={36} />
        <PowerIcon size={26} color={'#214796'} />
        <Spacer direction={'horizontal'} size={12} />
        {getModalView()}
      </Box>
    </Box>
  )
}

export { Header }

const NEW_GLOBAL_SEARCH_ROUTES = [
  'onboardEntity',
  'makerMyEntityQueue',
  'checker1MyQueue',
  'checker2MyQueue',
  'riskCheckerMyQueue',
  'riskMakerMyQueue',
  'checker1Queue',
  'checkerDetails',
  'checker2Queue',
  'riskCheckerQueue',
  'riskMakerQueue',
  'myOnboardedEntityDetails',
  'onboardingIncidents',
  'onboardingIncidentDetails',
]
